import request from '@/util/request'

// 运动员列表（分页）
export const getAthletePage = (data) => {
  return request({
    url: `/api/register/athlete/page`,
    method: 'GET',
    data
  })
}

// 运动员列表（不分页）
export const getAthleteList = (data) => {
  return request({
    url: `/api/register/athlete/list`,
    method: 'GET',
    data
  })
}

// 运动员导出列表（全赛事）
export const getAthleteExport = (data) => {
  return request({
    url: `/api/register/athlete/exportList`,
    method: 'GET',
    data,
    responseType: 'blob'
  })
}

// 新增/修改运动员
export const athleteEdit = (data) => {
  return request({
    url: `/api/register/athlete/edit`,
    method: 'POST',
    data
  })
}

// 运动员详情
export const getAthleteInfo = (id) => {
  return request({
    url: `/api/register/athlete/info/${id}`,
    method: 'GET',
  })
}

// 删除运动员
export const athleteDel = (data) => {
  return request({
    url: `/api/register/athlete/del`,
    method: 'POST',
    data
  })
}

// 运动员列表-个人项目
export const getAthleteListPersonProject = (data) => {
  return request({
    url: `/api/register/athlete/listPersonProject`,
    method: 'GET',
    data
  })
}

// 运动员列表-集体项目
export const getAthleteListTeamProject = (data) => {
  return request({
    url: `/api/register/athlete/listTeamProject`,
    method: 'GET',
    data
  })
}

// 运动员列表-对练项目
export const getAthleteListTrainProject = (data) => {
  return request({
    url: `/api/register/athlete/listTrainProject`,
    method: 'GET',
    data
  })
}

// 运动员身份证识别
export const athleteCertificateDiscern = (data) => {
  return request({
    url: `/api/business/athlete/certificateDiscern`,
    method: 'POST',
    data
  })
}
